export const SHOW_AGENT_STATUS = "SHOW_AGENT_STATUS";
export const AGENT_ACTIVE_LOADING = "AGENT_ACTIVE_LOADING";
export const FETCH_CONSUMED_CREDIT = "FETCH_CONSUMED_CREDIT";
export const USER_PLAN_SUCCESS = "USER_PLAN_SUCCESS";
export const APPLY_CONSUMED_CREDIT = "APPLY_CONSUMED_CREDIT";
export const EMPTY_GENERAL_STATE = "EMPTY_GENERAL_STATE";
